"use client";

import { LandingPageRenderer } from "@/components/landing/landing-page-renderer";
import { useNativeApp } from "@/hooks/use-native-app";
import { usePublicLandingPage } from "@/hooks/use-landing-page";
import {
  DEFAULT_LANDING_CSS,
  DEFAULT_LANDING_HTML,
} from "@/lib/landing/default-content";

export function PublicLandingPage() {
  const isNative = useNativeApp();
  const landingQuery = usePublicLandingPage("home", !isNative);
  const landing = landingQuery.data;

  if (isNative) {
    return <div className="min-h-screen bg-white" />;
  }

  return (
    <LandingPageRenderer
      title={landing?.title || "PraxisTárs"}
      html={landing?.html.trim() || DEFAULT_LANDING_HTML}
      css={landing?.css.trim() || DEFAULT_LANDING_CSS}
    />
  );
}
